export const authChannel = new BroadcastChannel('auth_channel');
export const assessmentsChannel = new BroadcastChannel('assessments_channel');
